// extracted by mini-css-extract-plugin
export default {"facebook-button":"FacebookButton--facebook-button---mxGR","facebookButton":"FacebookButton--facebook-button---mxGR"};